export const PKEY = {
  USER_TOKEN: 'token',
  USER_ID: 'idusuario',
  ALLOWED_LOCALES: 'allowedlocal',
  CLIENTE: 'cliente',
  OPERADOR: 'operador',
  OPERADOR_LIST: 'operadorList',
  USER_NAME: 'usuarionombre',
  USER_MAIL: 'mail',
  URL_ORIGIN: 'origin',
  URL_REDIRECT: 'redirect',
  USER_LOGIN_EXPIRE: 'login_expire',
  CURRENT_MODULE: 'module',
  COOKIE_ID: 'ITURRIIMPOSSID22',
  TERMS_CONDITIONS: 'termsconditions',
  TYPE_CONTAINER: 'tipocontenedor',
  SEARCH_CLIENTE_ID: 'clienteid',
  TYPE: 'type',

  PRIVIGELES: 'privileges',
  DEBUG: 'debug',

  MENU: 'menu',
};

